import { render, staticRenderFns } from "./Dog-Coowner-comp.vue?vue&type=template&id=0aa2bf04&scoped=true&"
import script from "./Dog-Coowner-comp.vue?vue&type=script&lang=js&"
export * from "./Dog-Coowner-comp.vue?vue&type=script&lang=js&"
import style0 from "./Dog-Coowner-comp.vue?vue&type=style&index=0&id=0aa2bf04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa2bf04",
  null
  
)

export default component.exports